import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation14 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };
    return (
        <>



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}>
                      Certificate Course in AutoCAD

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%" }}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in AutoCAD
                </h5>
                <p>
                    This course is designed for learners with Architectural or Engineering Background or for those who have keen interest in Computer Aided Designs (CAD). He/she can create and edit Architectural Floor Plans for Residential and Commercial Buildings, Interior Layout, Landscape Gardens, Location Plans etc. with AutoCAD. Learner will be able to draft 2D drawings. At the end of the course, learner can appear for International AutoCAD Certification and become AutoCAD Certified User.</p>


            </div>
            <hr />




            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>This course is designed for learners with Architectural or Engineering Background or for those who have keen interest in Computer Aided Designs (CAD). He/she can create and edit Architectural Floor Plans for Residential and Commercial Buildings, Interior Layout, Landscape Gardens, Location Plans etc. with AutoCAD. Learner will be able to draft 2D drawings. At the end of the course, learner can appear for International AutoCAD Certification and become AutoCAD Certified User.</p>
            <p>After completion of the course, you can work as:</p>
            <ul>
                <li>CAD Designer</li>
                <li>CAD Draftsman / CAD Operator</li>
            </ul>



            <hr></hr>

            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> AutoCAD course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
           
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                   
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Introduction to AutoCAD</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Introduction to CADMAN</li>
                                <li>Introduction to AutoCAD</li>
                                <li>User Interface of AutoCAD</li>
                                <li>File Formats used in AutoCAD</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Working with AutoCAD</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Introduction</li>
                                <li>Working with Line object</li>
                                <li>Erasing Objects</li>
                                <li>Using the Grid</li>
                                <li>Snap</li>
                                <li>Setup Drawing Units & Limits</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Input Data: Cartesian & Polar Method</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>Introduction</li>
                                <li>Coordinates & Coordinate System</li>
                                <li>Using Absolute Cartesian Method</li>
                                <li>Using Relative Cartesian Method</li>
                                <li>Using Polar Coordinate Method</li>
                                <li>Using Polar Tracking Method</li>
                                <li>Using Dynamic Input to Draw Objects</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Input Data: Cartesian & Polar Method</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Introduction</li>
                                <li>Coordinates & Coordinate System</li>
                                <li>Using Absolute Cartesian Method</li>
                                <li>Using Relative Cartesian Method</li>
                                <li>Using Polar Coordinate Method</li>
                                <li>Using Polar Tracking Method</li>
                                <li>Using Dynamic Input to Draw Objects</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Creating Objects</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Drawing an ARC</li>
                                <li>Drawing SPLINE n POLYLINE</li>
                                <li>Drawing CIRCLE n DONUT</li>
                                <li>Drawing an ELLIPSE</li>
                                <li>Drawing a RECTANGLE & POLYLINES</li>
                                <li>Using POINT</li>
                                <li>Using HATCH and GRADIENTS</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Modifying Objects</AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Modify Objects – MOVE</li>
                                <li>Modify Objects – COPY</li>
                                <li>Modify Objects – ROTATE</li>
                                <li>Modify Objects – OFFSET</li>
                                <li>Modify Objects – MIROR</li>
                                <li>Modify Objects – SCALE n STRETCH</li>
                                <li>Modify Objects – TRIM n EXTEND</li>
                                <li>Modify Objects – CHAMFER</li>
                                <li>Modify Objects – FILLET</li>
                                <li>Modify Objects – BREAK n JOIN</li>
                                <li>Modify Objects – ARRAY</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Object Snap,Selection & Properties</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li> Object Snap - OSNAP</li>
                                <li>Running OSnap & OSnap Tracking</li>
                                <li>Different Methods of Object Selection</li>
                                <li>Using GRIPS & Object Properties</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Navigation Controls:Zoom & Pan</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Objectives</li>
                                <li>Concept of Zoom & Pan</li>
                                <li>Zoom All</li>
                                <li>Zoom Extents</li>
                                <li>Zoom Real time</li>
                                <li>Zoom Center</li>
                                <li>Zoom Scale</li>
                                <li> Zoom Previous</li>
                                <li>Zoom Window</li>
                                <li>Zoom Object</li>
                                <li>Zoom Dynamic</li>
                                <li>Using Pan</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Annotation: Text & Dimensioning</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>Adding Text to Drawing</li>
                                <li>Creating Text Style</li>
                                <li>Creating Multiline Text</li>
                                <li>Adding Dimensions</li>
                                <li>Dimension Styles</li>
                                <li>Editing Dimensions</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Annotation: Text & Dimensioning</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Creating & Using Layers</li>
                                <li>Creating & Using Blocks</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



            </div >
            <hr />


            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation14;